module.exports = __webpack_public_path__ + "img/fail.jpg";